import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarItem from './menu';
import Logo from './logo';
import './Sidebar.scss';
import { useUser } from '../../contexts/UserContext';
import AddForm from '../modals/add-item';
import {
  canCreateLoads,
  canCreateCarriers,
  canCreateCustomers,
  canViewCarriers,
  canViewCustomers,
  canViewLoads,
  canViewPayments,
  canViewUsers,
  canViewLoadHistory,
  getUserRole
} from '../../utils/roleAccess';

const Sidebar = ({ collapsed, onToggle }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useUser();
  const role = getUserRole(user);
  
  const [addModalState, setAddModalState] = useState({
    isOpen: false,
    formType: null
  });

  const handleAddClick = (formType) => {
    setAddModalState({
      isOpen: true,
      formType
    });
  };

  const handleAddModalClose = () => {
    setAddModalState({
      isOpen: false,
      formType: null
    });
  };

  const handleAddModalSuccess = () => {
    handleAddModalClose();
    const currentPath = location.pathname;
    if (addModalState.formType === 'customers' && currentPath === '/customers') {
      window.location.reload();
    } else if (addModalState.formType === 'carriers' && currentPath === '/carriers') {
      window.location.reload();
    } else {
      if (addModalState.formType === 'customers') {
        navigate('/customers');
      } else if (addModalState.formType === 'carriers') {
        navigate('/carriers');
      }
    }
  };

  const menuItems = [
    {
      title: 'Statistics',
      icon: 'activity',
      path: '/statistics',
      exact: true,
    },
    ...(canViewLoads(role) ? [{
      title: 'Loads',
      icon: 'trucka',
      path: '/loads',
      children: [
        { title: 'All Loads', path: '/loads' },
        ...(canCreateLoads(role) ? [{ title: 'Add Load', path: '/loads/add' }] : []),
        ...(canViewLoadHistory(role) ? [{ title: 'Load History', path: '/loads/history' }] : []),
      ],
    }] : []),
    ...(canViewUsers(role) ? [{
      title: 'Users',
      icon: 'persona',
      path: '/users',
      children: [
        { title: 'All Users', path: '/users' },
      ],
    }] : []),
   
    ...(canViewPayments(role) ? [{
      title: 'Payments',
      icon: 'carda',
      path: '/payments',
      children: [
        { title: 'All Payments', path: '/payments' },
      ],
    }] : []),
   ...(canViewCustomers(role) ? [{
      title: 'Customers',
      icon: 'c',
      path: '/customers',
      children: [
        { title: 'All Customers', path: '/customers' },
        ...(canCreateCustomers(role) ? [{ title: 'Add Customers', path: '/customers/add', onClick: () => handleAddClick('customers') }] : [])
      ],
    }] : []),
    ...(canViewCarriers(role) ? [{
      title: 'Carriers',
      icon: 'carrier',
      path: '/carriers',
      children: [
        { title: 'All Carriers', path: '/carriers' },
        ...(canCreateCarriers(role) ? [{ title: 'Add Carrier', path: '/carriers/add', onClick: () => handleAddClick('carriers') }] : [])
      ],
    }] : []),
 

  ];

  return (
    <>
      <div className={`admin-sidebar ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <Logo/>
        </div>
        
        <Nav className="flex-column sidebar-nav">
          {menuItems.map((item, index) => (
            <SidebarItem
              key={index}
              item={item}
              collapsed={collapsed}
              location={location}
            />
          ))}
        </Nav>
      </div>

      {addModalState.isOpen && addModalState.formType && (
        <AddForm
          isOpen={addModalState.isOpen}
          setIsOpen={(isOpen) => {
            if (!isOpen) {
              handleAddModalClose();
            }
          }}
          formType={addModalState.formType}
          onSuccess={handleAddModalSuccess}
          onClose={handleAddModalClose}
        />
      )}
    </>
  );
};

export default Sidebar;
